export default __webpack_public_path__ + "static/media/banner_ours.4146d7a9.jpg";